/** @jsx jsx */
import { FC } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { css, jsx } from '@emotion/react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Layout, ArticleMaker } from '@components';
import { IArticleData } from '@src/components/Article/Article';

type IProps = {
    data: Typing.Query;
};
const SlidesTemplate: FC<IProps> = ({ data }) => {
    const mappingArticleMarkData = (): IArticleData[] => {
        const result: IArticleData[] = data.mdx.frontmatter.source.map((item) => {
            return {
                bannerPhoto: data.mdx.frontmatter?.bannerPhoto?.childImageSharp?.fluid?.src || null,
                title: item.title,
                date: data.mdx.frontmatter.date,
                authorPhoto: item.authorPhoto.childImageSharp.fluid.src,
                author: item.author,
                content: null,
                tags: [],
                link: item.pdfSrc.publicURL,
            };
        });

        return result;
    };
    return (
        <Layout title={data.mdx.frontmatter.title}>
            <Grid
                container
                spacing={2}
                css={css`
                    margin-top: calc(10vh);
                    flex-direction: column;
                `}
            >
                <Typography variant="h4" color="primary">
                    {data.mdx.frontmatter.title}
                </Typography>
                <ArticleMaker articleList={mappingArticleMarkData()} showAuthor />
            </Grid>
        </Layout>
    );
};
export default SlidesTemplate;
export const pageQuery = graphql`
    query($id: String!) {
        mdx(id: { eq: $id }, frontmatter: { type: { eq: "slides" }, published: { eq: true } }) {
            frontmatter {
                date(formatString: "YYYY/MM/DD")
                title
                bannerPhoto {
                    childImageSharp {
                        fluid {
                            src
                            originalName
                        }
                    }
                }
                source {
                    author
                    title
                    pdfSrc {
                        publicURL
                    }
                    authorPhoto {
                        childImageSharp {
                            fluid {
                                src
                            }
                        }
                    }
                }
            }
        }
    }
`;
